import {getServerTexts as getTexts, initTexts, texts as text} from '../../../Localization/texts';

const entity = 'UI_NEWANNOUNCE';

const he = {
    finalStep: 'סיום',
    okBtn: 'ספרו לי עוד',
    cancelBtn: 'לא תודה',
    nextBtn: 'המשך',
    backBtn: 'חזרה',
    showMe: 'לקריאה נוספת',
    closeTooltip: 'סגירה',
    //24.1
    welcomePageTitle: 'גלו את החידושים שמחכים לכם בפריוריטי',
    welcomePageText: 'יכולות חדשות ומתקדמות בעיצוב רענן לחוויית השימוש הטובה ביותר.',
    formDesignTitle: 'חווייה חדשה של עיצוב מסך',
    formDesignText: 'מעכשיו תוכלו להתאים אישית מסכים במהירות גם ע"י גרירת שדות ובחירה מרובה.',
    partDialogTitle: 'בחירת מוצרים מהירה ומדוייקת מקטלוג',
    partDialogText: 'בחרו מקטלוג כמה מוצרים בו זמנית. בדקו את יתרות המלאי ועדכנו כמויות.',
    bpmTitle: 'ניהול תהליכים (BPM) - חוויית משתמש מתקדמת ואינטואיטיבית',
    bpmText: 'צרו תרשים BPM בצורה קלה ונוחה. שילחו אימיילים אוטומטית לכמה מכותבים בו זמנית.',
    chartTitle: 'תרשימים ב- Priority Analytics (Visualization)',
    chartText: 'בחרו תרשים מספריית תרשימים מגוונת להצגת נתונים  בצורה ויזואלית ואטרקטיבית.',
    EOYTitle: 'תהליך יעודי ומהיר למעבר שנה',
    EOYText: 'השתמשו בתהליך מעבר שנה שמוביל אתכם צעד אחר צעד, בקלות ובמהירות לשנת הכספים החדשה.'
};

const en = {
    finalStep: 'Done',
    cancelBtn: 'No, thank you',
    nextBtn: 'Next',
    backBtn: 'Back',
    showMe: 'Show me',
    closeTooltip: 'Close',
    //24.1
    welcomePageTitle: 'Discover a new level of efficiency in your Priority experience.',
    welcomePageText:
        'Innovative capabilities and a fresh design, to elevate your business with transformative solutions.',
    formDesignTitle: 'Form Design',
    formDesignText: 'Personalize your forms faster with drag & drop and multi-select options.',
    partDialogTitle: 'Choose parts quicker',
    partDialogText:
        'Open the extended view to see pictures, check availability, select quantity, straight from the parts list.',
    bpmTitle: 'Enhanced BPM flow chart experience with a fresh look',
    bpmText: 'Create BPM flow charts efficiently. Automate emails to multiple recipients.',
    chartTitle: 'Visualize your data in Priority Analytics',
    chartText:
        'Choose from a chart library to show your data in a personalized, visually attractive report.',
    EOYTitle: 'Closing the year has never been easier',
    EOYText:
        'Go step-by-step through the year-end process, ensuring a smooth transition to the new fiscal year.'
};

const fallbacks = {
    en,
    he
};

export const mapping = {
    //24.1
    36: 'finalStep',
    101: 'closeTooltip',
    102: 'welcomePageTitle',
    103: 'welcomePageText',
    104: 'cancelBtn',
    105: 'ShowMe',
    106: 'formDesignTitle',
    107: 'formDesignText',
    108: 'nextBtn',
    109: 'backBtn',
    110: 'partDialogTitle',
    111: 'partDialogText',
    112: 'bpmTitle',
    113: 'bpmText',
    114: 'chartTitle',
    115: 'chartText',
    116: 'EOYTitle',
    117: 'EOYText'
};

export function getServerTexts() {
    return getTexts(entity, mapping);
}

initTexts(entity, fallbacks);

export const texts = text[entity];
